// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__1TCc_","alert":"SettungsInbox_alert__vBG-f"};